import React, { useState } from "react";
import "./style.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import AgendamentoMobile from "./AgendamentoMobile";
import AutorizacaoSaidaMobile from "./AutorizacaoSaidaMobile";
import CadastroPessoaMobile from "./CadastroPessoaMobile";
import PerfilMobile from "./PerfilMobile";
import RegistroEntradaMobile from "./RegistroEntradaMobile";
import RegistroSaidaMobile from "./RegistroSaidaMobile";
import VisitantesAgendadosMobile from "./VisitantesAgendadosMobile";

const Mobile = () => {
    const porteiro = Number(localStorage.getItem("userType")) === 1;
    const [activeComponent, setActiveComponent] = useState(
        porteiro ? "registro-entrada" : "agendamento"
    );
    const componentesSemNavegacao = [
        "visitantes-agendados",
        "visitantes-autorizados-entrada",
    ];
    const exibindoFluxoRegistroEntrada = [
        "registro-entrada",
        "visitantes-autorizados-entrada",
    ].includes(activeComponent);

    return (
        <>
            {" "}
            <div className="container-mobile">
                <div className="tela">
                    {activeComponent === "agendamento" && (
                        <AgendamentoMobile
                            setActiveComponent={setActiveComponent}
                        />
                    )}
                    {activeComponent === "perfil" && <PerfilMobile />}
                    {activeComponent === "cadastro-pessoa" && porteiro && (
                        <CadastroPessoaMobile />
                    )}
                    {exibindoFluxoRegistroEntrada && porteiro && (
                        <RegistroEntradaMobile
                            mostrarVisitantes={
                                activeComponent ===
                                "visitantes-autorizados-entrada"
                            }
                            setActiveComponent={setActiveComponent}
                        />
                    )}
                    {activeComponent === "registro-saida" && porteiro && (
                        <RegistroSaidaMobile />
                    )}
                    {activeComponent === "autorizacao-saida" && (
                        <AutorizacaoSaidaMobile />
                    )}
                    {activeComponent === "visitantes-agendados" && (
                        <VisitantesAgendadosMobile
                            setActiveComponent={setActiveComponent}
                        />
                    )}
                </div>
                {!componentesSemNavegacao.includes(activeComponent) && (
                    <div className="navegacao-inferior-mobile">
                        {porteiro ? (
                            <>
                                <button
                                    onClick={() =>
                                        setActiveComponent("cadastro-pessoa")
                                    }
                                    className={
                                        activeComponent === "cadastro-pessoa"
                                            ? "active"
                                            : ""
                                    }
                                >
                                    <i className="fas fa-user-plus"></i>
                                    Cadastrar Pessoa
                                </button>
                                <button
                                    onClick={() =>
                                        setActiveComponent("registro-entrada")
                                    }
                                    className={
                                        activeComponent === "registro-entrada"
                                            ? "active"
                                            : ""
                                    }
                                >
                                    <i className="fas fa-sign-in-alt"></i>
                                    Registrar Entrada
                                </button>
                                <button
                                    onClick={() =>
                                        setActiveComponent("registro-saida")
                                    }
                                    className={
                                        activeComponent === "registro-saida"
                                            ? "active"
                                            : ""
                                    }
                                >
                                    <i className="fas fa-door-open"></i>
                                    Registrar Saída
                                </button>
                            </>
                        ) : (
                            <>
                                <button
                                    onClick={() =>
                                        setActiveComponent("agendamento")
                                    }
                                    className={
                                        activeComponent === "agendamento"
                                            ? "active"
                                            : ""
                                    }
                                >
                                    <i className="fas fa-calendar-alt"></i>
                                    Agendar Visitante
                                </button>
                                <button
                                    onClick={() =>
                                        setActiveComponent(
                                            "autorizacao-saida"
                                        )
                                    }
                                    className={
                                        activeComponent ===
                                        "autorizacao-saida"
                                            ? "active"
                                            : ""
                                    }
                                >
                                    <i className="fas fa-sign-out-alt"></i>
                                    Autorizar Saída
                                </button>
                            </>
                        )}
                        <button
                            onClick={() => setActiveComponent("perfil")}
                            className={
                                activeComponent === "perfil" ? "active" : ""
                            }
                        >
                            <i className="fas fa-user"></i>
                            Perfil
                        </button>
                    </div>
                )}
            </div>
        </>
    );
};

export default Mobile;
